import { tv } from '~/utils/tv'

export const SnackbarContentVariants = tv({
  base: `
    flex flex-row gap-twopulse items-center justify-start
    px-fourpulse pt-fourpulse
  `,
})

export const SnackbarBoxTextVariants = tv({
  base: `
    flex flex-col w-full overflow-hidden gap-onepulse max-h-huge
  `,
})
